// extracted by mini-css-extract-plugin
export default {"container":"wood-board_container__Aafod","hooks":"wood-board_hooks__Jjnc1","hook-anchors":"wood-board_hook-anchors__mAxxz"};